import { AfterViewChecked, Component, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { FieldActivityIcon, FieldActivityType } from '@core/models/enums';
import { FieldActivityLogItemModel } from '@core/models/models';
import { cloneDeep } from 'lodash';
import { EXCREATIONSCREEN } from '@core/constants';

@Component({
  selector: 'caremoni-field-activity-item',
  templateUrl: './field-activity-item.component.html',
  styleUrl: './field-activity-item.component.scss'
})
export class FieldActivityItemComponent implements OnInit, AfterViewChecked {

  @Input() data: FieldActivityLogItemModel = new FieldActivityLogItemModel();
  @Input() config: any = {};
  
  @ViewChild('activityItemLog') activityItemLog!: any;
  @ViewChild('activityLabel') activityLabel!: any;
  displayText: string = '';
  activityType: FieldActivityType = FieldActivityType.GUIDANCE;
  activityIcon: FieldActivityIcon = FieldActivityIcon.GUIDANCE;
  FieldActivityType = FieldActivityType;
  cssImageStyle: any = {};
  imageIcon: string = FieldActivityIcon.GUIDANCE;
  attention_flg: boolean = false;
  blinking: boolean = false;
  styleBlock:any = {};
  styleIcon:any = {};
  cssImageStyleNotFullscreen: string = "";
  EXCREATIONSCREEN = EXCREATIONSCREEN;

  constructor(private ngZone: NgZone) {
    
  }

  ngOnInit(): void {
    let columns = Math.round(this.config.interval * 60 / this.config.timeInterval);  
    if(this.data) {
      this.activityType = this.data.type;
      this.blinking = this.data.blinking ?? false;
      if(this.data?.attention_flg && this.activityType == FieldActivityType.MEDICINENYUSHO) this.attention_flg = this.data?.attention_flg;
      this.imageIcon = this.getImageIcon();
      if(this.activityType == FieldActivityType.MEDICINE || this.activityType == FieldActivityType.MEDICINENYUSHO)  this.displayText = '薬';
      else  this.displayText = this.data?.volume || '';
      if(this.data.screen == EXCREATIONSCREEN.EXCREATION) this.styleIcon = 'icon';
      if(this.data.screen == EXCREATIONSCREEN.EXCREATION && this.data.attention_flg)  this.styleIcon = 'icon icon-background blink-yellow';
      if(this.data.screen == EXCREATIONSCREEN.EXCREATION && this.activityType == FieldActivityType.NO_EXCRETION) this.styleIcon = 'icon-diamond';
      if(this.data.screen == EXCREATIONSCREEN.EXCREATION && this.data.attention_flg && this.activityType == FieldActivityType.NO_EXCRETION) this.styleIcon = 'icon-diamond icon-background blink-yellow';
    }
  }

  private initialized = false;
  ngAfterViewChecked(): void {
    if (!this.initialized) {
      const cells = document.getElementsByClassName('field-activity-cell');
      if (cells.length) {
        this.initialized = true;
        this.getCellSize(false);
      }
    }
  }


  // @HostListener('document:fullscreenchange', ['$event'])
  // @HostListener('document:webkitfullscreenchange', ['$event'])
  // @HostListener('document:mozfullscreenchange', ['$event'])
  // @HostListener('document:MSFullscreenChange', ['$event'])
  // @HostListener('window:resize', ['$event'])
  // onResize() {
  //   this.ngZone.runOutsideAngular(() => {
  //     requestAnimationFrame(() => {
  //       this.ngZone.run(() => {
  //         this.getCellSize(true);
  //       });
  //     });
  //   });
  // }

  // lấy kích thước của item
  getCellSize(isFullscreen: boolean) {
    if(this.cssImageStyleNotFullscreen && !isFullscreen) {
      this.cssImageStyle = cloneDeep(this.cssImageStyleNotFullscreen);
      return;
    }

    // Lấy danh sách các activity log có class 'field-activity-cell'
    const cells = document.getElementsByClassName('field-activity-cell');
    if (!cells.length) return;
  
    // Lấy chiều cao của ô cuối cùng (giả định các ô có cùng kích thước)
    const heightElement = (cells[cells.length - 1] as HTMLElement).offsetHeight;
    const widthElement = (cells[cells.length - 1] as HTMLElement).offsetWidth;
    if (!heightElement) return;
  
    const numberColumn = ((this.config.interval * 60) / this.config.timeInterval);

    const scaleFactor = numberColumn > 2 ? 1 : 0.75;

    const widthPerItem = (widthElement / numberColumn) * scaleFactor;
    const heightPerItem = heightElement * scaleFactor;
    
    let lengthStyle = Math.min(widthPerItem, heightPerItem);

    //blinking cho to 1 chút;
    this.styleBlock = this.data.blinking ? {width: `${(lengthStyle * 1.35)}px`} : {};

    if(this.activityType === FieldActivityType.NO_EXCRETION) {
      lengthStyle = (lengthStyle * 1.3);// Hình thoi cho to 1 chút;
    }
    
    // Gán width, height cho icon
    this.cssImageStyle = { 
      ...this.cssImageStyle, // Giữ nguyên các giá trị trước đó
      width: `${lengthStyle}px`, height: `${lengthStyle}px`,
    };

    if(isFullscreen) {
      this.cssImageStyleNotFullscreen = cloneDeep(this.cssImageStyle);
    }

  }  

  getImageIcon() {
    switch (this.activityType) {
      case FieldActivityType.GUIDANCE:
        return FieldActivityIcon.GUIDANCE; 
      case FieldActivityType.DEFECATION:
        return FieldActivityIcon.DEFECATION;
      case FieldActivityType.MEDICINENYUSHO:
      case FieldActivityType.MEDICINE:
        return FieldActivityIcon.MEDICINE;
      case FieldActivityType.URINATION:
        return FieldActivityIcon.URINATION;

      case FieldActivityType.CHECK:
        return FieldActivityIcon.CHECK;
      case FieldActivityType.PLUS:
        return FieldActivityIcon.PLUS;
      case FieldActivityType.NO_EXCRETION:
        return FieldActivityIcon.NO_EXCRETION;
      default:
        return "";
    }
  }

  isStandardIcon(type: FieldActivityType, text: string): boolean {
    const validTypes = [FieldActivityType.URINATION, FieldActivityType.DEFECATION];
    return validTypes.includes(type);
  }
  
  getIconPath(type: FieldActivityType, text: string): string {
    const validTypes = [FieldActivityType.URINATION, FieldActivityType.DEFECATION];
    const validTexts = ['普', '少', '多'];
    if (validTypes.includes(type) && validTexts.includes(text)) {
      return `../../../../../assets/icons/${type}_${text}.svg`;
    } else {
      return `../../../../../assets/icons/${type}_excreation_icon.svg`;
    }
  }
}
